import { createContext, useContext } from "react";
import { DEFAULT_LOCALE, type Locale } from "./locales";

// The context and its hook live apart from the provider COMPONENT so that
// `LocaleProvider.tsx` exports a component and nothing else — the condition
// React Fast Refresh needs to hot-swap it without dropping state.

export const LocaleContext = createContext<Locale>(DEFAULT_LOCALE);

/**
 * Reading outside a provider yields `DEFAULT_LOCALE` rather than throwing, and
 * the reason is bounded: English IS the fallback the business wants, and German
 * is only reachable under `/de/*`, which the router mounts inside the provider.
 * A subtree rendered outside it can therefore render English early, never German
 * copy mislabelled as English.
 */
export function useLocale(): Locale {
  return useContext(LocaleContext);
}
